<template>
    <div class="grid-home" style="height:100%;">
      <div class="title-box">
          洁净车间监控管理·全局总览
      </div>
      <el-row :gutter="10">
        <el-col :span="8">
          <div class="grid-content">
            <span class="pre-title"></span>
            <span class="col-title">监控覆盖情况</span>
            <el-row>
              <el-col :span="12" style="text-align:center;">
                <el-row style="margin-top:10px;">
                  <el-col :span="12">
                    <div class="num-div" style="color:#01EC92;">{{totalFactoryCount}}</div>
                    <div class="title-div">工厂数</div>
                  </el-col>
                  <el-col :span="12">
                    <div class="num-div" style="color:#3083FB">{{totalMonitoringFactoryCount}}</div>
                    <div class="title-div">监控工厂数</div>
                  </el-col>
                </el-row>
                <el-row style="margin-top:10px;">
                  <el-col :span="12">
                    <div class="num-div" style="color:#3083FB;">{{totalWorkshopsCount}}</div>
                    <div class="title-div">车间数</div>
                  </el-col>
                  <el-col :span="12">
                    <div class="num-div" style="color:#3083FB;">{{totalMonitoringWorkshopsCount}}</div>
                    <div class="title-div">监控车间数</div>
                  </el-col>
                </el-row>
                <el-row style="margin-top:10px;">
                  <el-col :span="12">
                    <div class="num-div" style="color:#3083FB;">{{totalScenesCount}}</div>
                    <div class="title-div">场景数</div>
                  </el-col>
                  <el-col :span="12">
                    <div class="num-div" style="color:#3083FB;">{{totalMonitoringScenesCount}}</div>
                    <div class="title-div">监控场景数</div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="10" :offset="1">
                <div id="mintorGauge" style="width:130px;height:130px;margin:auto;"></div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content">
            <div id="preWeekChart" style="height:80px;margin:auto;"></div>
            <el-row>
              <el-col :span="12" id="curChart" style="height:80px;margin:auto;"></el-col>
              <el-col :span="12" id="preDayChart" style="height:80px;margin:auto;"></el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">
            <span class="pre-title"></span>
            <span class="col-title">当前分类报警数</span>
            <el-row class="alarmNum">
              <el-col :span="8" class="bjNum bjLv">{{pressureAlarmsCount}}</el-col>
              <el-col :span="8" class="bjNum bjLan">{{airCleanlinessAlarmsCount}}</el-col>
              <el-col :span="8" class="bjNum bjCheng">{{ozoneAlarmsCount}}</el-col>
            </el-row>
            <el-row class="alarmTitle">
              <el-col :span="8">压差报警</el-col>
              <el-col :span="8">空气洁净报警</el-col>
              <el-col :span="8">臭氧浓度报警</el-col>
            </el-row>
            <el-row class="alarmNum">
              <el-col :span="8" class="bjNum bjHong">{{wetTemperatureAlarmsCount}}</el-col>
              <el-col :span="8" class="bjNum bjQing">{{forbiddenZoneAlarmsCount}}</el-col>
              <el-col :span="8" class="bjNum bjZi">{{washoutExecutionAlarmsCount}}</el-col>
            </el-row>
            <el-row class="alarmTitle">
              <el-col :span="8">湿温度报警</el-col>
              <el-col :span="8">禁区闯入报警</el-col>
              <el-col :span="8">洗消执行报警</el-col>
            </el-row>
          </div>
        </el-col>
          <el-col :span="5">
          <div class="grid-content">
            <span class="pre-title"></span>
            <span class="col-title">用户当前登录情况</span>
            <div style="display:flex;">
              <div class="userDiv">
                <div class="alarmNum allNum">{{userCnt}}</div>
                <div class="alarmTitle">总用户数</div>
              </div>
              <div class="userDiv" style="margin-left:10px;">
                <div class="alarmNum onlineNum">{{onlineUserCnt}}</div>
                <div class="alarmTitle">在线用户数</div>
              </div>
            </div>
            <!-- <div class="userRow"></div>
            <div class="userRow"></div>
            <div class="userRow"></div> -->
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <div style="height:520px;margin:10px 0;">
          <el-col :span="13">
            <div id="chinaMap" class="grid-content"  style="height:333px;"></div>
            <div style="margin-top:10px;display:flex;">
              <div class="grid-content"  id="dayBar" style="height:145px;flex:1;margin-right:10px;"></div>
              <div class="grid-content"  id="weekBar" style="height:145px;flex:1;margin-right:10px;"></div>
              <div class="grid-content"  id="loginBar" style="height:145px;flex:1;"></div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content" style="height:488px;">
              <span class="pre-title"></span>
              <span class="col-title">当前报警场景分布</span>
              <el-row class="alarmNum">
                <el-col :span="8" class="bjNum cjHong">{{totalAlarmFactoryCount}}</el-col>
                <el-col :span="8" class="bjNum cjLan">{{totalAlarmWorkshopsCount}}</el-col>
                <el-col :span="8" class="bjNum cjLv">{{totalAlarmScenesCount}}</el-col>
              </el-row>
              <el-row class="alarmTitle">
                <el-col :span="8">报警工厂数</el-col>
                <el-col :span="8">报警车间数</el-col>
                <el-col :span="8">报警场景数</el-col>
              </el-row>
              <el-table :data="factoryWorkshopsAlarmDetailList" height="370" border style="width: 100%;margin-top:10px;overflow-x:auto;" class="custom-table-header">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="工厂" prop="factoryName" width="80" header-align="center"></el-table-column>
                <el-table-column label="车间" prop="workshopName" header-align="center"></el-table-column>
                <el-table-column label="报警数" prop="alarmCount" width="60" header-align="center"></el-table-column>
              </el-table>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="grid-content" style="height:185px;">
              <span class="pre-title"></span>
              <span class="col-title">高频用户排行榜</span>
              <div class="highUser" v-for="(item,index) in freqUserList" :key="index">
                <span :class="{'sortSpan':true,'firstSpan':index==0||index==1,'secondSpan':index== 2,'thrdSpan':index==3||index==4}">{{ index+1 }}</span>
                <span>{{item.nickName}}</span>
              </div>
            </div>
            <div class="grid-content" style="height:292px;margin-top:10px;">
              <span class="pre-title"></span>
              <span class="col-title">用户高频登录时段</span>
              <div class="higTime">
                <el-row :gutter="5">
                  <el-col :span="8" v-for="(item,index) in loginTimeList" :key="index" style="margin-top:5px;">
                    <el-tooltip :content="item.percent+'%'" placement="top">
                      <span v-if="item.percent<=0.1" class="spanBg1">{{ item.timePeriod }}</span>
                      <span v-else-if="item.percent>0.1 && item.percent<=0.2" class="spanBg2">{{ item.timePeriod }}</span>
                      <span v-else-if="item.percent>0.2 && item.percent<=0.3" class="spanBg3">{{ item.timePeriod }}</span>
                      <span v-else class="spanBg4">{{ item.timePeriod }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
              </div>
              
            </div>
          </el-col>
        </div>
      </el-row>
    </div>
</template>
<script>
  import * as echarts from 'echarts';
  import china from '@/plugins/echarts/map/json/china.json' 
  import {getDateOneWeekAgo, getWeekOfMonth, formatDate, formatDateTime} from "@/utils/base"
  export default {
    data() {
      return {
        userCnt:0,//用户总数
        onlineUserCnt:0,//在线用户数
        freqUserList:[],//高频使用用户列表
        totalFactoryCount:0,
        totalMonitoringFactoryCount: 0,
        totalWorkshopsCount: 0,
        totalMonitoringWorkshopsCount: 0,
        totalScenesCount: 0,
        totalMonitoringScenesCount: 0,
        coverageRate: 0.0,
        pressureAlarmsCount: 0,
        airCleanlinessAlarmsCount: 0,
        ozoneAlarmsCount: 0,
        wetTemperatureAlarmsCount: 0,
        forbiddenZoneAlarmsCount: 0,
        washoutExecutionAlarmsCount: 0,
        totalAlarmFactoryCount: 0,
        totalAlarmWorkshopsCount: 0,
        totalAlarmScenesCount: 0,
        factoryWorkshopsAlarmDetailList: [],
        gaugeChart:null,
        weekChart:null,
        curChart:null,
        preChart:null,
        mapchart:null,
        dayBar:null,
        weekBar:null,
        loginBar:null,
        points: [],
        loginTimeList:[],//登录时间段统计
        resizeHandler: null
      }
    },
    activated() {
      if(this.$store.state.login.token){
        this.resizeHandler();
        window.addEventListener('resize', this.resizeHandler);
      }
    },
    deactivated() {
      if(this.$store.state.login.token){
        this.disposeHandler();
      }
      window.removeEventListener('resize', this.resizeHandler);
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.resizeHandler);
    },
    mounted() {
      this.initUserStats();
      this.initPeriodStats();
      this.initFreqUser();
      this.initMonitorCoverageStats();
      this.initAlarmClassificationStats();
      this.initAlarmScenarioDistributionStats();
      this.getLastWeekScoreData();
      this.getCurrWeekScoreData();
      this.getYesterdayScoreData();
      this.initMap();
      this.initDayBar();
      this.initWeekBar();
      this.initLoginBar();
      this.resizeHandler = () => {
        if(this.$store.state.login.token){
          if(this.gaugeChart){
            this.gaugeChart.resize();
          }
          else{
            this.initMonitorCoverageStats();
          }
          if(this.weekChart){
            this.weekChart.resize();
          }
          else{
            this.getLastWeekScoreData();
          }
          if(this.curChart){
            this.curChart.resize();
          }
          else{
            this.getCurrWeekScoreData();
          }
          if(this.preChart){
            this.preChart.resize();
          }
          else{
            this.getYesterdayScoreData();
          }
          if(this.mapchart){
            this.mapchart.resize();
          }
          else{
            this.initMap();
          }
          if(this.dayBar){
            this.dayBar.resize();
          }
          else{
            this.initDayBar();
          }
          if(this.weekBar){
            this.weekBar.resize();
          }
          else{
            this.initWeekBar();
          }
          if(this.loginBar){
            this.loginBar.resize();
          }
          else{
            this.initLoginBar();
          }
        }
      };
    },
    methods: {
      // 用户统计
      initUserStats(){
        this.$store.dispatch('home/getUserStats').then((result)=>{
          if(result?.data){
            let data = result.data;
            this.userCnt = data.userCnt;
            this.onlineUserCnt = data.onlineUserCnt;
          }
        })
      },
      // 登录时间段统计
      initPeriodStats(){
        this.$store.dispatch('home/getPeriodStats').then((result)=>{
          if(result?.data){
            this.loginTimeList = result.data;
          }
        })
      },
      // 高频使用用户列表
      initFreqUser(){
        this.$store.dispatch('home/getFreqUser').then((result)=>{
          if(result?.data){
            this.freqUserList = result.data;
          }
        })
      },
      // 企业端-首页-监控覆盖情况统计
      initMonitorCoverageStats(){
        this.$store.dispatch('home/getMonitorCoverageStats').then((result)=>{
          if(result?.data){
            let data = result.data;
            this.totalFactoryCount = data.totalFactoryCount;
            this.totalMonitoringFactoryCount = data.totalMonitoringFactoryCount;
            this.totalWorkshopsCount = data.totalWorkshopsCount;
            this.totalMonitoringWorkshopsCount = data.totalMonitoringWorkshopsCount;
            this.totalScenesCount = data.totalScenesCount;
            this.totalMonitoringScenesCount = data.totalMonitoringScenesCount;
            this.coverageRate = data.coverageRate;
            this.$nextTick(()=>{
              this.initGaugeChart();
            })
          }
        });
      },
      // 企业端-首页-分类报警统计
      initAlarmClassificationStats(){
        this.$store.dispatch('home/getAlarmClassificationStats').then((result)=>{
          if(result?.data){
            let data = result.data;
            this.pressureAlarmsCount = data.pressureAlarmsCount;
            this.airCleanlinessAlarmsCount = data.airCleanlinessAlarmsCount;
            this.ozoneAlarmsCount = data.ozoneAlarmsCount;
            this.wetTemperatureAlarmsCount = data.wetTemperatureAlarmsCount;
            this.forbiddenZoneAlarmsCount = data.forbiddenZoneAlarmsCount;
            this.washoutExecutionAlarmsCount = data.washoutExecutionAlarmsCount;
          }
        });
      },
      // 企业端-首页-报警场景分布统计
      initAlarmScenarioDistributionStats(){
        this.$store.dispatch('home/getAlarmScenarioDistributionStats').then((result)=>{
          if(result?.data){
            let data = result.data;
            this.totalAlarmFactoryCount = data.totalAlarmFactoryCount;
            this.totalAlarmWorkshopsCount = data.totalAlarmWorkshopsCount;
            this.totalAlarmScenesCount = data.totalAlarmScenesCount;
            this.factoryWorkshopsAlarmDetailList = data.factoryWorkshopsAlarmDetailList;
          }
        });
      },
      // 监控覆盖率
      initGaugeChart(){
        let dom = document.getElementById('mintorGauge');
        if(dom){
          this.gaugeChart = echarts.init(dom);
          let option = {
              series: [
                  {
                      // name: '业务指标',
                      type: 'gauge',
                      startAngle: -270,
                      endAngle: 90,
                      radius:'100%',
                      center: ['50%', '50%'],
                      min: 0,
                      max: 100,
                      pointer: {
                        show: false
                      },
                      progress: {
                        show: true,
                        overlap: false,
                        roundCap: true,
                        clip: false,
                        itemStyle: {
                          color: '#3083FB'
                        }
                      },
                      title: {
                        fontSize: 12
                      },
                      detail: {
                        fontSize: 18,
                        offsetCenter: [0, '-10%'],
                        formatter: '{value}%'
                      },
                      splitLine: {
                        show: false
                      },
                      axisTick: {
                        show: false
                      },
                      axisLabel: {
                        show: false
                      },
                      data: [{value: this.coverageRate, name: '监控覆盖率'}]
                  }
              ]
          };
          this.gaugeChart.setOption(option);
        }
      },
      // 上周管控得分
      initWeekChart(data){
        let dom = document.getElementById('preWeekChart');
        if(dom){
          this.weekChart = echarts.init(dom);
          let option = {
              series: [
                  {
                      // name: '业务指标',
                      type: 'gauge',
                      startAngle: 215,
                      endAngle: -45,
                      radius:'90%',
                      center: ['50%', '50%'],
                      min: 0,
                      max: 100,
                      pointer: {
                        show: false
                      },
                      progress: {
                        show: true,
                        overlap: false,
                        roundCap: true,
                        clip: false,
                        itemStyle: {
                          color: '#01EC92'
                        }
                      },
                      title: {
                        offsetCenter: [0, '100%'],
                        fontSize: 12
                      },
                      detail: {
                        fontSize: 18,
                        offsetCenter: [0, '-10%'],
                        // formatter: '{value}%'
                      },
                      axisLine: {
                        lineStyle: {
                          width: 5
                        }
                      },
                      splitLine: {
                        show: false
                      },
                      axisTick: {
                        show: false
                      },
                      axisLabel: {
                        show: false
                      },
                      data: [{value: data, name: '上周管控得分'}]
                  }
              ]
          };
          this.weekChart.setOption(option);
        }
      },
      // 当前管控得分
      initCurChart(data){
        let dom = document.getElementById('curChart');
        if(dom){
          this.curChart = echarts.init(dom);
          let option = {
              series: [
                  {
                      // name: '业务指标',
                      type: 'gauge',
                      startAngle: 215,
                      endAngle: -45,
                      radius:'90%',
                      center: ['50%', '50%'],
                      min: 0,
                      max: 100,
                      pointer: {
                        show: false
                      },
                      progress: {
                        show: true,
                        overlap: false,
                        roundCap: true,
                        clip: false,
                        itemStyle: {
                          color: '#F9AE3A'
                        }
                      },
                      title: {
                        offsetCenter: [0, '100%'],
                        fontSize: 12
                      },
                      detail: {
                        fontSize: 18,
                        offsetCenter: [0, '-10%'],
                        // formatter: '{value}%'
                      },
                      axisLine: {
                        lineStyle: {
                          width: 5
                        }
                      },
                      splitLine: {
                        show: false
                      },
                      axisTick: {
                        show: false
                      },
                      axisLabel: {
                        show: false
                      },
                      data: [{value: data, name: '当前管控得分'}]
                  }
              ]
          };
          this.curChart.setOption(option);
        }
      },
      // 昨日管控得分
      initPreChart(data){
        let dom = document.getElementById('preDayChart');
        if(dom){
          this.preChart = echarts.init(dom);
  
          let option = {
              series: [
                  {
                      // name: '业务指标',
                      type: 'gauge',
                      startAngle: 215,
                      endAngle: -45,
                      radius:'90%',
                      center: ['50%', '50%'],
                      min: 0,
                      max: 100,
                      pointer: {
                        show: false
                      },
                      progress: {
                        show: true,
                        overlap: false,
                        roundCap: true,
                        clip: false,
                        itemStyle: {
                          color: '#52C5FF'
                        }
                      },
                      title: {
                        offsetCenter: [0, '100%'],
                        fontSize: 12
                      },
                      detail: {
                        fontSize: 18,
                        offsetCenter: [0, '-10%'],
                        // formatter: '{value}%'
                      },
                      axisLine: {
                        lineStyle: {
                          width: 5
                        }
                      },
                      splitLine: {
                        show: false
                      },
                      axisTick: {
                        show: false
                      },
                      axisLabel: {
                        show: false
                      },
                      data: [{value: data, name: '昨日管控得分'}]
                  }
              ]
          };
          
          this.preChart.setOption(option);
        }
      },
      // 查询上周管控得分
      getLastWeekScoreData(){
        this.$store.dispatch('home/getLastWeekScore').then((result)=>{
          let data = 0
          if(result?.data){
            data = result?.data;
          }
          this.$nextTick(()=>{
            this.initWeekChart(data)
          })
        })
      },
      // 查询当前管控得分
      getCurrWeekScoreData(){
        this.$store.dispatch('home/getCurrWeekScore').then((result)=>{
          let data = 0
          if(result?.data){
            data = result?.data;
          }
          this.$nextTick(()=>{
            this.initCurChart(data)
          })
        })
      },
      // 查询昨日管控得分
      getYesterdayScoreData(){
        this.$store.dispatch('home/getYesterdayScore').then((result)=>{
          let data = 0
          if(result?.data){
            data = result?.data;
          }
          this.$nextTick(()=>{
            this.initPreChart(data)
          })
        })
      },
      //初始化地图
      initMap() {
        echarts.registerMap('china', china); //注册地图数据
        let dom = document.getElementById("chinaMap")
        if(dom){
          this.mapchart = echarts.init(dom);
          const option = {
            geo: {
              map: 'china',
              roam: true,
              zoom: 1.2,
              label: {
                show: false
              },
              itemStyle:{
                borderColor: '#4f94f8',
                areaColor: '#f2f2f2',  //地图的背景色
                shadowBlur:10,
                shadowColor:'#e2e9f2'
              },
              emphasis: {
                label: {
                  show: false
                },
                itemStyle: { // 高亮状态下的多边形和标签样式
                  areaColor:'#f2f2f2',
                  shadowBlur:10,
                  shadowColor:'#e2e9f2',
                }
              }
            },
            series: [
              {
                name: '点位数据',
                type: 'scatter',
                coordinateSystem: 'geo',
                encode: {
                  value: 2
                },
                label: {
                  show: true,
                  position: 'top',
                  color: '#000', // 文字颜色
                  fontSize: 12,
                  backgroundColor: '#fff', // 背景颜色
                  borderRadius: 5, // 圆角
                  padding: [5, 10], // 内边距
                  borderWidth: 1, // 边框宽度
                  borderColor: '#3083FB', // 边框颜色
                  formatter: '{b}',
                  rich: {
                    a: {
                        color: '#fff',
                        fontSize: 14,
                        fontWeight: 'bold'
                    }
                  }
                },
                itemStyle: {
                  color: '#fd3f59',
                  shadowBlur: 10,
                  shadowColor: 'rgba(0, 0, 0, 0.3)'
                }
              }
            ]
          }
          this.mapchart.setOption(option);
          this.$store.dispatch('home/getFactoryMap').then((result)=>{
            let data = result.data
            this.points = data.map(point => ({
                name: point.factoryName,
                value: [point.longitude, point.latitude],
                longitude: point.longitude,
                latitude: point.latitude
              })
            )
            option.series[0].data = this.points;
            this.mapchart.setOption(option);
          })
        }
        
      },
      // 日报送读情况
      initDayBar(){
        this.$store.dispatch('home/getDailyStat').then((result)=>{
          let data = result.data
          let dateArr = []
          let subCntArr = []
          let dviewCntArr = []
          let dviewRateArr = []
          for(let i=0;i<data.length;i++){
            dateArr.push(data[i].statDate)
            subCntArr.push(data[i].subCnt)
            dviewCntArr.push(data[i].dviewCnt)
            dviewRateArr.push(data[i].dviewRate)  
          }
          let chartDom = document.getElementById('dayBar');
          if(chartDom){
            this.dayBar = echarts.init(chartDom);
            let option;
            option = {
              title: {
                text: '日报送读情况',
                textStyle:{
                  fontSize:10
                },
                left: "center"
              },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'cross',
                  crossStyle: {
                    color: '#999'
                  }
                }
              },
              legend: {
                bottom: -5,
                itemGap: 2,
                itemWidth: 11,
                itemHeight: 4,
                textStyle: {
                  fontSize: 8
                },
                data: ['日报推送人数', '日报阅读人数', '日报阅读率']
              },
              grid: {
                left: 25,
                top: 20,
                right: 25,
                bottom: 40
              },
              xAxis: [
                {
                  type: 'category',
                  data: dateArr,
                  axisPointer: {
                    type: 'shadow'
                  },
                  axisLabel:{
                    fontSize:8
                  }
                }
              ],
              yAxis: [
                {
                  type: 'value',
                  min: 0,
                  axisLabel: {
                    formatter: '{value}',
                    fontSize:8
                  }
                },
                {
                  type: 'value',
                  interval: 5,
                  axisLabel: {
                    formatter: '{value}%',
                    fontSize:8
                  }
                }
              ],
              series: [
                {
                  name: '日报推送人数',
                  type: 'bar',
                  itemStyle:{
                    color:"rgba(48, 131, 251, 1)"
                  },
                  data: subCntArr
                },
                {
                  name: '日报阅读人数',
                  type: 'bar',
                  itemStyle:{
                    color:"rgba(251, 215, 48, 1)"
                  },
                  data: dviewCntArr
                },
                {
                  name: '日报阅读率',
                  type: 'line',
                  yAxisIndex: 1,
                  itemStyle:{
                    color:"rgba(1, 236, 146, 1)"
                  },
                  tooltip: {
                    valueFormatter: function (value) {
                      return value + '%';
                    }
                  },
                  data: dviewRateArr
                }
              ]
            };
            option && this.dayBar.setOption(option);
          }
        })
      },
      // 当月周报送读情况
      initWeekBar(){
        const sevenDaysAgo = new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000);
        this.$store.dispatch('home/getWeekStat').then((result)=>{
          let data = result.data
          let weekArr = []
          let subCntArr = []
          let wviewCntArr = []
          let wviewRateArr = []
          for(let i=0;i<data.length;i++){
            weekArr.push(data[i].statWeek)
            subCntArr.push(data[i].subCnt)
            wviewCntArr.push(data[i].wviewCnt)
            wviewRateArr.push(data[i].wviewRate)  
          }
          let chartDom = document.getElementById('weekBar');
          if(chartDom){
            this.weekBar = echarts.init(chartDom);
            let month = new Date().getMonth() + 1
            let option;
            option = {
              title: {
                text: month+'月份周报送读情况',
                textStyle:{
                  fontSize:10
                },
                left: "center"
              },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'cross',
                  crossStyle: {
                    color: '#999'
                  }
                }
              },
              legend: {
                bottom: -5,
                itemGap: 2,
                itemWidth: 11,
                itemHeight: 4,
                textStyle: {
                  fontSize: 8
                },
                data: ['周报推送人数', '周报阅读人数', '周报阅读率']
              },
              grid: {
                left: 25,
                top: 20,
                right: 25,
                bottom: 40
              },
              xAxis: [
                {
                  type: 'category',
                  data: weekArr,
                  axisPointer: {
                    type: 'shadow'
                  },
                  axisLabel:{
                    fontSize:8
                  }
                }
              ],
              yAxis: [
                {
                  type: 'value',
                  interval: 50,
                  axisLabel: {
                    formatter: '{value}',
                    fontSize:8
                  }
                },
                {
                  type: 'value',
                  interval: 5,
                  axisLabel: {
                    formatter: '{value}%',
                    fontSize:8
                  }
                }
              ],
              series: [
                {
                  name: '周报推送人数',
                  type: 'bar',
                  itemStyle:{
                    color:"rgba(48, 131, 251, 1)"
                  },
                  data: subCntArr
                },
                {
                  name: '周报阅读人数',
                  type: 'bar',
                  itemStyle:{
                    color:"rgba(251, 215, 48, 1)"
                  },
                  data: wviewCntArr
                },
                {
                  name: '周报阅读率',
                  type: 'line',
                  yAxisIndex: 1,
                  itemStyle:{
                    color:"rgba(1, 236, 146, 1)"
                  },
                  tooltip: {
                    valueFormatter: function (value) {
                      return value + '%';
                    }
                  },
                  data: wviewRateArr
                }
              ]
            };
            option && this.weekBar.setOption(option);
          }
        })
      },
      // 近7日用户登录数及时长
      initLoginBar(){
        let dateArr = []
        for(let i=0;i<7;i++){
          let day = getDateOneWeekAgo(i).split("-")
          let month = Number(day[1])<10?Number(day[1]):day[1]
          dateArr.push(`${month}月${day[2]}`)
        }
        dateArr.reverse();
        let chartDom = document.getElementById('loginBar');
        if(chartDom){
          this.loginBar = echarts.init(chartDom);
          let option;
          option = {
            title: {
              text: '近7日用户登录数及时长',
              textStyle:{
                fontSize:10
              },
              left: "center"
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                crossStyle: {
                  color: '#999'
                }
              }
            },
            legend: {
              bottom: -5,
              itemGap: 2,
              itemWidth: 11,
              itemHeight: 4,
              textStyle: {
                fontSize: 8
              },
              data: ['登录用户数', '用户累计在线时长（h）']
            },
            grid: {
              left: 25,
              top: 20,
              right: 0,
              bottom: 40
            },
            xAxis: [
              {
                type: 'category',
                data: dateArr,
                axisPointer: {
                  type: 'shadow'
                },
                axisLabel:{
                  fontSize:8
                }
              }
            ],
            yAxis: [
              {
                type: 'value',
                // name: '日报推送人数',
                // min: 0,
                // max: 250,
                interval: 50,
                axisLabel: {
                  formatter: '{value}',
                  fontSize:8
                }
              }
            ],
            series: [
              {
                name: '登录用户数',
                type: 'bar',
                itemStyle:{
                  color:"rgba(48, 131, 251, 1)"
                },
                data: [
                  2.0, 4.9, 7.0, 23.2, 5.6, 76.7, 15.6, 12.2, 3.6, 20.0, 6.4, 3.3
                ]
              },
              {
                name: '用户累计在线时长（h）',
                type: 'bar',
                itemStyle:{
                  color:"rgba(251, 215, 48, 1)"
                },
                data: [
                  2.6, 5.9, 9.0, 6.4, 8.7, 7.7, 15.6, 12.2, 8.7, 18.8, 6.0, 2.3
                ]
              }
            ]
          };
          option && this.loginBar.setOption(option);
        }
      },
      disposeHandler(){
        if(this.gaugeChart){
          this.gaugeChart.dispose();
          this.gaugeChart = null;
        }
        if(this.weekChart){
          this.weekChart.dispose();
          this.weekChart = null;
        }
        if(this.curChart){
          this.curChart.dispose();
          this.curChart = null;
        }
        if(this.preChart){
          this.preChart.dispose();
          this.preChart = null;
        }
        if(this.mapchart){
          this.mapchart.dispose();
          this.mapchart = null;
        }
        if(this.dayBar){
          this.dayBar.dispose();
          this.dayBar = null;
        }
        if(this.weekBar){
          this.weekBar.dispose();
          this.weekBar = null;
        }
        if(this.loginBar){
          this.loginBar.dispose();
          this.loginBar = null;
        }
      }
    }
}
</script>
<style lang="scss" scoped>
  .title-box{
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        padding: 27px 0 15px;
        line-height: 16px;
    }
  .grid-home {
    overflow-y: auto;
    .grid-title {
      font-size: 16px;
      margin-bottom: 15px;
      display: inline-block;
      font-weight: bold;
      color: #323232;
    }
    .grid-content{
      height: 175px;
      background: #fff;
      border-radius: 3px;
      padding: 10px;
      .pre-title{
          display: inline-block;
          width: 3px;
          height: 12px;
          background-color: #3083FB;
          border-radius: 1.5px;
          margin-right: 5px;
          margin-bottom: -1.5px;
      }
      .col-title{
        font-size: 14px;
      }
      .num-div{
        font-size: 16px;
        font-weight: bold;
        // text-align: center;
      }
      .title-div{
        font-size: 12px;
        color:#666666;
      }
      .alarmTitle{
        font-size: 12px;
        color: #666666;
        text-align: center;
      }
      .alarmNum{
        font-size: 26px;
        text-align: center;
        height: 50px;
      }
      .allNum{
        height: auto;
        color: #3083FB;
        font-size: 20px;
      }
      .onlineNum{
        height: auto;
        color: #F9AE3A;
        font-size: 20px;
      }
      .userDiv{
        height: 53px;
        width: 48%;
        padding:7px 0;
        box-shadow: 3px 3px 13px 0px rgba(205, 205, 205, 0.57);
        border-radius: 5px;
        margin-top: 10px;
      }
      .userRow{
        font-size: 12px;
        color: rgba(102, 102, 102, 1);
        line-height: 15px;
        margin-top: 10px;
        text-align: center;
      }
    }
  } 
  /* 表头背景色 */
  ::v-deep .custom-table-header th{
      background-color: #ebeef5 !important;
  }
  ::v-deep .custom-table-header .el-table__row{
      height: 10px; /* 设置你想要的行高 */
  }
  ::v-deep .custom-table-header .el-table__body-wrapper{
    overflow-x: hidden;
  }
   /* 表格内边距 */
    ::v-deep .custom-table-header .el-table__cell {
        padding: 5px 0;
    }
  /* 表格字体大小 */
  .el-table {
      font-size: 12px;
  }
  .highUser{
    font-size: 12px;
    margin-top: 10px;
    color: rgba(102, 102, 102, 1)
  }
  .sortSpan{
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    background: rgba(243, 243, 247, 1);
    font-weight: bold;
    color: rgba(102, 102, 102, 1);
    text-align: center;
    line-height: 20px;
  }
  .firstSpan{
    color:rgba(251, 83, 38, 1);
  }
  .secondSpan{
    color:rgba(39, 105, 241, 1);
  }
  .thrdSpan{
    color:rgba(153, 153, 177, 1);
  }
  .higTime span{
    display: inline-block;
    height: 31px;
    border-radius: 4px;
    font-size: 10px;
    text-align: center;
    line-height: 31px;
    padding:0 5px;
    white-space: nowrap;
  }
  .spanBg1{
    background: #e0edff;
    cursor: pointer;
  }
  .spanBg2{
    background: #bfd9ff;
    cursor: pointer;
  }
  .spanBg3{
    background: #7bb1ff;
    cursor: pointer;
  }
  .spanBg4{
    background: #3083fb;
    cursor: pointer;
  }
  .bjNum{
    line-height: 56px;
  }
  .bjLv{
    background: url('../../assets/home/bj-lv.png') center/56px no-repeat;
  }
  .bjLan{
    background: url('../../assets/home/bj-lan.png') center/56px no-repeat;
  }
  .bjCheng{
    background: url('../../assets/home/bj-cheng.png') center/56px no-repeat;
  }
  .bjHong{
    background: url('../../assets/home/bj-hong.png') center/56px no-repeat;
  }
  .bjQing{
    background: url('../../assets/home/bj-qing.png') center/56px no-repeat;
  }
  .bjZi{
    background: url('../../assets/home/bj-zi.png') center/56px no-repeat;
  }
  .cjHong{
    background: url('../../assets/home/cj-hong.png') center/56px no-repeat;
  }
  .cjLan{
    background: url('../../assets/home/cj-lan.png') center/56px no-repeat;
  }
  .cjLv{
    background: url('../../assets/home/cj-lv.png') center/56px no-repeat;
  }
</style>